import { create } from 'zustand';

// Définition des types pour notre store
export interface AppointmentModalState {
    isOpen: boolean;
    initialData: {
      name?: string;
      email?: string;
      phone?: string;
      datetime?: string;
      comments?: string;
    } | null;
    // Actions
    open: (initialData?: AppointmentModalState['initialData']) => void;
    close: () => void;
  }

// Création du store Zustand
export const useAppointmentModalStore = create<AppointmentModalState>((set) => ({
    isOpen: false,
    initialData: null,
    open: (initialData = null) => {
      // Vérification côté client pour éviter les erreurs lors du SSR
      if (typeof window !== 'undefined') {
        set({ isOpen: true, initialData });
      }
    },
    close: () => set({ isOpen: false, initialData: null }),
  }));
